<template>
  <div class="view confirmation">

    <div class="text-container">
      <div class="icon"></div>
      <div class="icon-title">{{ $t('confirmation.confirmed') }}</div>
      <p class="text" v-if="cart.confirmationMessage">{{ cart.confirmationMessage }}</p>
    </div>

    <h2>{{ $t('confirmation.order') }}</h2>

    <order-summary :cart="cart" :thumbnail="true" />

  </div>
</template>

<script>

import OrderSummary from '@/components/OrderSummary';
import Cart from '@/models/Cart';

export default {
  props: ['bookingId', 'be'],

  data() {
    return {
      cart: new Cart(),
      company: "Zaui Software"

    }
  },

  components: {
    OrderSummary
  },

  created() {
    Cart.loadBooking(this.bookingId, this.be).then(data => {

      // This needs to use some sort of authorization
      this.cart = Cart.query().with('items').where('bookingId', this.bookingId).first();
    }).catch((err) => {
      if (!err.error){
        // alert(`Unkown error: ${err}`);
      }
      else {
        // alert(`ERROR: ${err.error.message}`);
      }

      this.$router.push({name: 'home'});
    });
  }
};
</script>

<style lang="scss">
.view.confirmation {
  .text-container {
    text-align: center;
    margin: 40px auto 30px auto;
    max-width: 420px;
    line-height: 22px;

    .icon {
      @include font-awesome($fa-var-check-circle, light);
      font-size: 62px;
      color: $colorGreen;
      margin-bottom: 12px;
      @include breakpoint(medium) {
        font-size: 72px;
      }
    }

    .icon-title {
      @include font-large;
      color: $colorGreen;
      margin-bottom: 15px;
    }
  }
}
</style>